import PropTypes from 'prop-types';
import React from 'react';
import { GoogleLoginButton } from 'react-social-login-buttons';

const socialAuthButtonsStyle = {
  display: 'block',
  borderRadius: '25px',
  color: 'black',
  cursor: 'pointer',
  margin: '0px',
  width: '100%',
  overflow: 'hidden',
  userSelect: 'none',
  height: '50px',
  textAlign: 'center',
  background: 'var(--falcon-btn-falcon-background)',
  border: 'var(--falcon-border-width) solid var(--falcon-gray-300)',
  boxShadow: 'var(--falcon-box-shadow-sm)'
};

const SocialAuthButtons = ({ authActionText }) => {
  const loginWithGoogle = async () => {
    window.location.href = `${process.env.REACT_APP_SERVER_URL}/auth/google`;
    return;
  };

  return (
    <div className="mt-3">
      <GoogleLoginButton
        onClick={loginWithGoogle}
        align="center"
        style={socialAuthButtonsStyle}
        className="px-3 btn btn-falcon-default"
      >
        <h5 className="mb-0 fs-9">{authActionText} con Google</h5>
      </GoogleLoginButton>
      {/* <AppleLoginButton
        onClick={() => alert('Il login con Apple non è ancora supportato')}
        align="center"
        style={socialAuthButtonsStyle}
        className="px-3 mt-2"
      >
        <h5 className="mb-0 fs-9">{authActionText} con Apple</h5>
      </AppleLoginButton> */}
    </div>
  );
};

//create prop types for the component. authActionText is a string and is required. it must be "Accedi" or "Registrati"
SocialAuthButtons.propTypes = {
  authActionText: PropTypes.oneOf(['Accedi', 'Iscriviti']).isRequired
};

export default SocialAuthButtons;
